module.exports = __webpack_public_path__ + "img/una merda.cd64674f.png";